<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Smarter screening across Africa</h2>
    <p>Asoko Projects is our on-demand service that acts as an extension of your risk and compliance teams, enabling them to more efficiently mitigate risk through company verification and bespoke research across Africa. Retrieve public and litigation records on company shareholders and directors to verify ownership and control for compliance and  KYC assessments on a project-by-project basis.</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'risk-advisor-teams-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Risk Advisor/Compliance Teams Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Risk Advisor/Compliance Teams Block',
      })
      this.$router.push({ name: 'solutions-page' })
    },
  },
}
</script>
